import appMetadata from '@mvecom/common/utils/appMetadata';
import { useEffect, useMemo, useState } from 'react';

type FetchResult =
  | { status: 'Loading' }
  | { status: 'Success'; data: string | undefined }
  | { status: 'Error'; error: Error };

export const useSparepartsUrl = () => {
  const [fetchState, setFetchState] = useState<FetchResult>({ status: 'Loading' });

  useEffect(() => {
    const controller = new AbortController();
    const ru = appMetadata.getRetailUnit();
    const lc = appMetadata.getLanguage();

    const linkConfig = `/global/assets/commerce/common/configurations/${ru}/links/links.${lc}.json`;

    fetch(linkConfig, { signal: controller.signal })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        if (!controller.signal.aborted) {
          setFetchState({ status: 'Success', data: data['spareParts'] as string | undefined });
        }
      })
      .catch((error) => {
        if (error.name === 'AbortError') {
          return;
        }
        console.error(error);
        setFetchState({ status: 'Error', error });
      });

    return () => {
      controller.abort();
    };
  }, []);

  return useMemo(
    () => ({
      sparepartsUrl: fetchState.status === 'Success' ? fetchState.data : undefined,
      status: fetchState.status,
    }),
    [fetchState],
  );
};
